/* eslint func-names: off */
;(function () {
  if (window.subscriptionWidgetInitialized) {
    /* eslint no-console: off */
    __console_log('Subscription Widget already initialized')

    return
  }

  function debug(...messages) {
    __console_log('[RODEO DEBUG]', ...messages)
  }

  window.subscriptionWidgetInitialized = true

  const widgetScript = document.querySelector('[data-subscription-app-id]')
  // debug({widgetScript, dataset: widgetScript && widgetScript.dataset})
  if (widgetScript && widgetScript.dataset.subscriptionAppId === 'RODEO') {
    var count = 0
    const interval = setInterval(() => {
      const ReChargeWidget = window.ReChargeWidget
      // debug({'ReChargeWidget': ReChargeWidget, destroy: ReChargeWidget && ReChargeWidget.destroyAllWidgets})
      if (ReChargeWidget && ReChargeWidget.destroyAllWidgets) {
        if (!ReChargeWidget.getWidgets) {
          ReChargeWidget.destroyAllWidgets()
        } else if (ReChargeWidget.getWidgets().length > 0) {
          // debug({widgets: [...ReChargeWidget.getWidgets()]})
          // ReChargeWidget.destroyAllWidgets()
          ReChargeWidget.getWidgets().forEach(
            widget => widget.widgetInstance && widget.widgetInstance.unmount()
          )
        }
      }

      count++

      if (count >= 100) {
        clearInterval(interval)
        // debug('no more interval to find recharge :-(')
      }
    }, 100)
  }

  var lastPurchaseOption = ''
  const widgets = document.querySelectorAll(
    '.subscription-widget--container'
  )

  widgets.forEach(widget => {
    const priceBlockId = widget.dataset.priceBlockId
    const priceBlock = document.getElementById(priceBlockId)
    const productPriceElement = priceBlock.querySelectorAll(
      '.price__sale .price-item'
    )
    const originalPriceElement = priceBlock.querySelector(
      '.price__regular .price-item, .price__sale .price-item.price-item--regular'
    )
    const comparePriceElement = priceBlock.querySelector(
      '.unit-price .price-item'
    )

    const variants = widget.querySelectorAll('.subscription-variant')
    console.log([originalPriceElement, productPriceElement])

    variants.forEach(variant => {
      const purchaseOptionInputs = variant.querySelectorAll(
        'input[name="purchase_option"]'
      )

      purchaseOptionInputs.forEach(purchaseOptionInput => {
        purchaseOptionInput.addEventListener('click', e => {
          debug('purchase type click', e)
          // switch toggle
          variant.querySelectorAll('.subscription-purchase-option').forEach(el => {
            // override theme js
            el.style.display = ''
            el.classList.remove('subscription-purchase-option--active')
          })

          const purchaseOption = e.target

          purchaseOption
            .closest('.subscription-purchase-option')
            .classList.add('subscription-purchase-option--active')

          lastPurchaseOption = purchaseOption.value

          const sellingPlans = variant.querySelector('[name="selling_plan"]')

          if (lastPurchaseOption === 'subscription') {
            sellingPlans.disabled = false

            updatePriceDisplay(variant)
          } else {
            sellingPlans.disabled = true

            resetPriceDisplay(variant)
          }
        })
      })
    })

    /**
     * Remove inactive variant sections from DOM temporarily
     */
    variants.forEach(variant => {
      if (variant.className.indexOf('subscription-variant--active') === -1) {
        variant.remove()
      } else if (variant.dataset.subscriptionOnly === 'true') {
        const purchaseOptionInput = variant.querySelector(
          'input[name="purchase_option"][value="subscription"]'
        )
        // trigger theme js things
        purchaseOptionInput.click()

        setTimeout(() => {
          // again for good measure
          purchaseOptionInput.click()
        }, 500)
      }
    })

    const productFormId = widget.dataset.productFormId
    const productForm = document.getElementById(productFormId)
    const variantIdInput = productForm.querySelector('[name="id"]')

    productForm.addEventListener('change', e => {
      // Not in the current widget
      if (!widget.contains(e.target)) {
        return
      }

      const selectedVariantId = variantIdInput.value

      variants.forEach(variant => {
        const { variantId } = variant.dataset

        if (selectedVariantId !== variantId) {
          variant.style.display = 'none'
          variant.classList.remove('subscription-variant--active')
          variant.remove()
        } else {
          variant.style.removeProperty('display')
          variant.classList.add('subscription-variant--active')

          widget.appendChild(variant)

          const purchaseOptionInput = variant.querySelector(
            `input[name="purchase_option"][value="${lastPurchaseOption}"]`
          )
          purchaseOptionInput.click()
        }
      })

      refreshPriceDisplay(widget)
    })

    refreshPriceDisplay(widget)

    function refreshPriceDisplay(widget) {
      const activeVariant = widget.querySelector('.subscription-variant--active')

      if (activeVariant) {
        var purchaseOptionInput =
          activeVariant.querySelector(
            'input[name="purchase_option"]:checked'
          ) || activeVariant.querySelector('input[name="purchase_option"]')

        if (purchaseOptionInput.value === 'subscription') {
          updatePriceDisplay(activeVariant)
        } else {
          resetPriceDisplay(activeVariant)
        }
      } else {
        resetPriceDisplay()
      }
    }

    function updatePriceDisplay(variant, productPrice) {
      const sellingPlans = variant.querySelector('[name="selling_plan"]')
      const sellingPlan = sellingPlans.querySelector('option:checked')
      const discountPercentage = sellingPlan.dataset.discount
      const originalPrice = variant.dataset.price
      const discountedPrice = sellingPlan.dataset.price

      const discountElement = variant.querySelector(
        '.subscription-purchase-option-subscription .subscription-purchase-option--price'
      )
      const discountPercentElement = discountElement.querySelector(
        '.subscription-variant-discount--percentage'
      )
      const discountPriceElement = discountElement.querySelector(
        '.subscription-variant-discount--price'
      )
      try{
          discountPercentElement.textContent = discountPercentage
      }catch{
        
      }
      discountPriceElement.textContent = discountedPrice

      productPriceElement.forEach(element => {
        element.textContent = discountedPrice
      })
      originalPriceElement.textContent = discountedPrice // originalPrice
    }

    function resetPriceDisplay(variant) {
      if (!variant) {
        return
      }

      const originalPrice = variant.dataset.price

      productPriceElement.forEach(element => {
        element.textContent = originalPrice
      })
      originalPriceElement.textContent = originalPrice
    }
  })
})()
